import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "jalali-moment";

import { MyList } from "../../components/";
import { useRequest } from "../../utils";
//locall

const GetUsers = (props) => {
  //   const [data, setData] = useState(null);
  const [page, setPage] = useState(1);

  const [
    get_users_error,
    get_users_loading,
    get_users_data,
    get_users_function,
  ] = useRequest({
    method: "post",
    url: "/get_users",
    body: {
      page,
    },
  });
  useEffect(() => {
    get_users_function().then(() => null);
  }, [page]);
  console.log(get_users_data);

  //   const { cookies } = props.cookies;

  //   useEffect(() => {
  //     axios
  //       .post(
  //         "/shoppingbasket_get_list",
  //         {
  //           page: page,
  //         },
  //         {
  //           headers: {
  //             Authorization: cookies.token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         if (res) {
  //           setData(res.data);
  //         }
  //       });
  //   }, [page, cookies.token]);

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        {get_users_data ? (
          <MyList
            data={get_users_data.result.docs}
            pages={get_users_data.result.totalPages}
            totalDocs={get_users_data.result.totalDocs}
            //   token={cookies.token}
            setPage={setPage}
            page={page}
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetUsers };
